import { Button, Popup } from 'antd-mobile';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { CloseOutline } from 'antd-mobile-icons';
import Styles from './index.module.scss';

interface IProps {
  children: any;
  title?: string;
  bodyStyle?: any;
  okText?: string;
  onOk?: Function;
}

const SLPopup = (
  { children, bodyStyle, title, okText = '确定', onOk, ...props }: IProps,
  ref
) => {
  const [visible, setVisible] = useState(false);
  const popUpStyle = {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    minHeight: '40vh',
    ...bodyStyle,
  };

  useImperativeHandle(ref, () => {
    return {
      open: () => {
        setVisible(true);
      },
      close: () => {
        setVisible(false);
      },
    };
  });

  return (
    <Popup
      visible={visible}
      onClose={() => setVisible(false)}
      bodyStyle={popUpStyle}
      className={Styles.popup}
    >
      {title && (
        <div className={Styles.header}>
          <span>{title}</span>
          <CloseOutline onClick={() => setVisible(false)} />
        </div>
      )}
      <div className={Styles.body}>{children}</div>
      <div className={Styles.footer}>
        <Button color="primary" block onClick={() => onOk()}>
          {okText}
        </Button>
      </div>
    </Popup>
  );
};

export default forwardRef(SLPopup);
